import {useAuth} from "../../providers/authprovider";
import React, {useEffect, useState} from "react";
import {Modal, Table} from "react-bootstrap";

export default function HistoryModal(props){
    const {calendar} = useAuth();

    const [history, setHistory] = useState(undefined)

    const onHide = ()=>{
        props.onHide();
    }

    useEffect(()=>{
        if(history!==undefined)
            return;

        loadEventsHistory();
    })

    const loadEventsHistory = ()=>{
        calendar.getHistory(response=>{
            const {success, content} = response;

            if(success === true){
                setHistory(content.sort((a,b)=>b.i - a.i));
            }
        })
    }

    return (
        <Modal
            show={props.show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton className={"historyModalHeader"}>
                <Modal.Title>Historia edycji</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table size={"sm"} bordered >
                    <thead>
                    <tr>
                        <th>L.p.</th>
                        <th>Pracownik</th>
                        <th>Rodzaj</th>
                        <th>Data wydarzenia</th>
                        <th>Wydarzenie</th>
                        <th>Data edycji</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        history?.map((h, i)=>
                            <tr key={h.i}>
                                <th>{i+1}</th>
                                <td>{h.user_info}</td>
                                <td>{h.event_info}</td>
                                <td>{new Date(Date.parse(h.date)).toLocaleDateString()}</td>
                                <td>{h.name}</td>
                                <td>{new Date(Date.parse(h.created_at)-3600*2*1000).toLocaleString()}</td>
                            </tr>
                        )
                    }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
